import { render, staticRenderFns } from "./StatisticsWebhooks.vue?vue&type=template&id=42d81146"
import script from "./StatisticsWebhooks.vue?vue&type=script&lang=js"
export * from "./StatisticsWebhooks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports